"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eCommmonWarnCategory = exports.eCommmonDebugLogCategory = exports.eCommmonErrorCategory = exports.eApplicationsErrorCategoryCommon = exports.ErrorCodeCommon = exports.LoggerConstants = void 0;
class LoggerConstants {
}
exports.LoggerConstants = LoggerConstants;
LoggerConstants.hidden = 'Hidden';
LoggerConstants.nocode = 'nocode';
class ErrorCodeCommon {
}
exports.ErrorCodeCommon = ErrorCodeCommon;
ErrorCodeCommon.CODE_DEFECT = 'CFRME000001';
var eApplicationsErrorCategoryCommon;
(function (eApplicationsErrorCategoryCommon) {
    eApplicationsErrorCategoryCommon["CODE_DEFECT"] = "CODE_DEFECT";
})(eApplicationsErrorCategoryCommon = exports.eApplicationsErrorCategoryCommon || (exports.eApplicationsErrorCategoryCommon = {}));
var eCommmonErrorCategory;
(function (eCommmonErrorCategory) {
    eCommmonErrorCategory["CONFIG_ERROR"] = "CONFIG_ERROR";
    eCommmonErrorCategory["INTER_SERVICE_REQUEST_ERROR"] = "INTER_SERVICE_REQUEST_ERROR";
    eCommmonErrorCategory["MESSAGE_BUS_ERROR"] = "MESSAGE_BUS_ERROR";
    eCommmonErrorCategory["SERVICE_AVAILABILITY_ERROR"] = "SERVICE_AVAILABILITY_ERROR";
    eCommmonErrorCategory["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    eCommmonErrorCategory["INTERNAL_UNKNOWN_ERROR"] = "INTERNAL_UNKNOWN_ERROR";
    eCommmonErrorCategory["CLIENT_ERROR"] = "CLIENT_ERROR";
    eCommmonErrorCategory["ELASTIC_ERROR"] = "ELASTIC_ERROR";
})(eCommmonErrorCategory = exports.eCommmonErrorCategory || (exports.eCommmonErrorCategory = {}));
var eCommmonDebugLogCategory;
(function (eCommmonDebugLogCategory) {
    eCommmonDebugLogCategory["MONGO"] = "MONGO";
})(eCommmonDebugLogCategory = exports.eCommmonDebugLogCategory || (exports.eCommmonDebugLogCategory = {}));
var eCommmonWarnCategory;
(function (eCommmonWarnCategory) {
    eCommmonWarnCategory["RETRY_WARNING"] = "RETRY_WARNING";
})(eCommmonWarnCategory = exports.eCommmonWarnCategory || (exports.eCommmonWarnCategory = {}));
